import React, { Component } from 'react';

const ErrorMsg = (props) => {
    return (
        (props[props.target] ? <div className="error-msg" style={{ display: (props[props.target] ? "block" : "none") }}>{props[props.target].error}</div> : "")
    )
}
const DomField = (props) => {
    (!props[props.name] && props.onLoad ? props.onLoad(props.name, props.isRequired ? props.isRequired : false, props.shouldValidate ? props.shouldValidate : false) : null);
    return (
        <div className="field">
            {/* <ErrorMsg target={props.name}  {...props} /> */}
            <input value={(props[props.name] ? props[props.name].value : "")} type={props.type} className={(props[props.name] && props[props.name].error ? "error" : "")} placeholder={(props[props.name] && props[props.name].error ? (props[props.name].value ? props[props.name].value : props[props.name].error) : props.placeholder)} name={props.name} id={props.id} onChange={props.onChange} />
        </div>
    )
}
const DomSelect = (props) => {
    (!props[props.name] && props.onLoad ? props.onLoad(props.name, props.isRequired ? props.isRequired : false, props.shouldValidate ? props.shouldValidate : false) : null);

    return (
        <div className={`field ${(props[props.name] && props[props.name].error ? "error" : "")}`}>
            <select className={props[props.name] && parseInt(props[props.name].value) >= 0 ? " selected" : ""} placeholder={props.placeholder} name={props.name} id={props.id} onChange={props.onChange} title={props.placeholder} defaultValue={-1}>
                <option value="-1" disabled={true}>מין</option>
                <option value="0">זכר</option>
                <option value="1">נקבה</option>
            </select>
        </div>
    )
}

const DomTextarea = (props) => {
    (!props[props.name] && props.onLoad ? props.onLoad(props.name, props.isRequired ? props.isRequired : false, props.shouldValidate ? props.shouldValidate : false) : null);
    let _defaults = {
        ...props._settings
    }
    return (
        <div className="field textarea">
            {/* <ErrorMsg target={props.name}  {...props} /> */}
            <textarea value={(props[props.name] ? props[props.name].value : "")}
                {..._defaults}
                placeholder={(props[props.name] && props[props.name].error ? (props[props.name].value ? props[props.name].value : props[props.name].error) : props.placeholder)}
                className={(props[props.name] && props[props.name].error ? "error" : "")} name={props.name} id={props.id} onChange={props.onChange}></textarea>
        </div>
    )
}
const DomCheckboxField = (props) => {
    const isChecked = {
        checked: (props[props.name].value == 0 ? false : true)
    }
    return (
        <div className={`field checkbox ${(props[props.name] && props[props.name].error ? "error" : "")}`}>
            {/* <ErrorMsg target={props.name}  {...props} /> */}
            <input {...isChecked} type={props.type} placeholder={props.placeholder} className={(props[props.name] && props[props.name].error ? "error" : "")} name={props.name} id={props.id} value={1} onChange={props.onChange} />
            <label htmlFor={props.id}>קראתי את <a href="https://z.ynet.co.il/mshort/commerce/2018/____/takanon.htm" title="" target="_blank">התקנון</a> ואני מאשר/ת</label>
        </div>
    )
}
const DomBoolCheckbox = (props) => {
    (!props[props.name] && props.onLoad ? props.onLoad(props.name, props.isRequired ? props.isRequired : false, props.shouldValidate ? props.shouldValidate : false) : null);
    const isChecked = props[props.name] ? {
        checked: (props[props.name].value == 0 ? false : true)
    } : { checked: false }
    return (
        <div className={`field terms ${(props[props.name] && props[props.name].error ? "error" : "")}`}>
            {/* <ErrorMsg target={props.name}  {...props} /> */}
            <input {...isChecked}  data-bool="true" type="checkbox" className={(props[props.name] && props[props.name].error ? "error" : "")} placeholder={props.placeholder} name={props.name} id={props.id} value={props.value} onChange={props.onChange} />

            {props.label ? <label htmlFor={props.id} dangerouslySetInnerHTML={{ __html: props.label }}></label> : ""}
        </div>
    )
}

const DomCustomImage = (props) => {
    (!props[props.name] && props.onLoad ? props.onLoad(props.name, props.isRequired ? props.isRequired : false, props.shouldValidate ? props.shouldValidate : false) : null);
    const clickbox = (node) => {
        window.document.getElementById(node).click();
    }
    return (
        <div className="field image">
            <input ref={input => input = this.input} 
            type="file" name={props.name} id={props.id} onChange={props.onChange} />
            <div className={`imagebox${(props[props.name] && props[props.name].error ? " error" : "")}`} onClick={() => { clickbox(props.id) }}>
                <div className="label"><div className="placeholder" dangerouslySetInnerHTML={{ __html: (props[props.name] && props[props.name].error ? props[props.name].error : props.placeholder)}}></div></div>
                <div className="plus"></div>
            </div>
            <p>עד 5 MB</p>
        </div>
    )
}

export {
    DomCheckboxField,
    DomTextarea,
    DomBoolCheckbox,
    DomField,
    DomCustomImage,
    ErrorMsg,
    DomSelect
}


// WEBPACK FOOTER //
// ./src/Components/Services/formDOM.jsx